import {Component, OnInit} from '@angular/core';
import {DateTime} from 'luxon';

@Component({
  selector: 'terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})

export class TermsComponent implements OnInit{
  public currentYear: string = DateTime.now().toFormat('y');

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
